import { render, staticRenderFns } from "./mp4Play.vue?vue&type=template&id=4142be3a"
import script from "./mp4Play.vue?vue&type=script&lang=js"
export * from "./mp4Play.vue?vue&type=script&lang=js"
import style0 from "./mp4Play.vue?vue&type=style&index=0&id=4142be3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports